import { params } from "brainloper-ui";
import { UserWO } from "../administration/user-WO";
import { WorkOrderResponsible } from "./work-order-responsible";

export interface IWorkOrder {
  id?: number;
  responsibleId?: number;
  responsible?: string;
  executionDate?: string;
  description?: string;
  activityId?: number;
  descriptionActivities?: string;
  equipmentId?: number;
  code?: string;
  componentId?: number;
  authorizesId?: number;
  estimatedTime?: number;
  maintenanceType?: string;
  active?: number;
  resources?: string;
  creatorId?: number;
  authorized?: number;
  cost?: number;
  currentOdometer?: number;
  odometer?: number;
  consecutive?: number;
  equipmentBrand?: string;
  component?: string;
  authorizes?: string;
  readyResources?: number;
  userWO?: UserWO[];
  responsiblesBody?: WorkOrderResponsible;
  maintenanceProvider?: string;
  traccarDeviceId?: number;
  invoiceReference?: string;
}

export class WorkOrder implements IWorkOrder {
  id?: number;
  responsibleId?: number;
  responsible?: string;
  executionDate?: string;
  description?: string;
  activityId?: number;
  descriptionActivities?: string;
  equipmentId?: number;
  code?: string;
  componentId?: number;
  authorizesId?: number;
  estimatedTime?: number;
  maintenanceType?: string;
  active?: number;
  resources?: string;
  creatorId?: number;
  authorized?: number;
  cost?: number;
  currentOdometer?: number;
  consecutive?: number;
  readyResources?: number;
  odometer?: number;
  equipmentBrand?: string;
  component?: string;
  authorizes?: string;
  userWO?: UserWO[];
  responsiblesBody?: WorkOrderResponsible;
  maintenanceProvider?: string;
  traccarDeviceId?: number;
  invoiceReference?: string;


}

export enum enumWorkOrderStates {
  TO_AUTHORIZE = 1,
  IN_EXECUTION = 2,
  TO_DISPATCH = 3,
  HISTORICAL = 4
}
